import React, { useState } from 'react';
import "../../iqac.css"
import TopNav from '../../../../../Components/TopNav';
import Navbar from '../../../../../Components/Navbar';
import DropdownNav from '../../../../../Components/DropdownNav';
import Footer from '../../../../../Components/Footer';
import Example from '../../../../../Components/Example';
import ScrollToTop from 'react-scroll-to-top';

const FEEDBACK = () => {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <div>
      <Example />
      <ScrollToTop smooth top="1000" />
      <div className='navbar-area'>
        <div className='feedback-image'>
          <div className='image-cover'>

          </div>
        </div>

      </div>

      {/* This iqac details part */}

      <div className='iqac-details'>
        <div className='iqac-header'>
          <h1>Internal Quality Assurance Cell - (IQAC)</h1>
          <h1 className='iqac-obj-tit'>FEEDBACK</h1>
        </div>
      </div>

      <div className='iqac-obj-det'>
        <button onClick={() => setIsOpen(e => !e)}           style={{
            marginTop: "20px",
            backgroundColor: "#0c4da2",
            padding: ".7rem",
            color: "white",
            width: "30%",
            alignItems: "center",
            marginLeft: "5%",
            borderRadius: ".3rem",
            cursor: "pointer",
            textAlign: "left",
          }}>Feedback Details</button>
        {
          isOpen && (
            <div className='ssr-items'>
              {/* This is the starting node of AQARREPORTS */}
              <div>
                <div className='aqar-items'>
                  <a href='https://docs.google.com/forms/d/e/1FAIpQLSeTuvaEaeiZDwFK9TtqHCmenPi0IVufTExpkZQofEurAmUAZw/viewform' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>Employers Feedback </h3>
                  </a>
                </div>
              </div>
              {/* This is the starting node of AQARREPORTS */}
              <div>
                <div className='aqar-items'>
                  <a href='https://docs.google.com/forms/d/e/1FAIpQLSfiPTS_B1OI40mqcAqRTZZtwKaci46wqYqaFIYUZ6YXAYSbxQ/viewform' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>
                      Parents Feedback </h3>
                  </a>
                </div>
              </div>
              {/* This is the starting node of AQARREPORTS */}
              <div>
                <div className='aqar-items'>
                  <a href='https://docs.google.com/forms/d/e/1FAIpQLSfN2kuFJ111BdsGBw1IfJhvOjsJJoc8hQDlxZCLE7cO4P-wYQ/viewform' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>Alumini Feedback</h3>
                  </a>
                </div>
              </div>
              {/* This is the starting node of AQARREPORTS */}
              <div>
                <div className='aqar-items'>
                  <a href='https://forms.gle/MgpE7sViP1uTs4bC7' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>Teachers Feedback</h3>
                  </a>
                </div>
              </div>


            </div>
          )

        }


      </div>

      <Footer />


    </div>
  );
}

export default FEEDBACK;
